import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Seleção de país/estado e de idioma do Super Guia, entregue ao nativo.
//
// Na web são dois selects numa barra sticky. Dentro do app essa barra come altura no topo de toda
// tela e ainda concorre com a barra de vidro logo acima dela — enquanto o iOS já tem o lugar certo
// para isso: um botão na navigation bar com menu suspenso, que marca a opção ativa. A barra web
// fica escondida no app (native.css).
//
// O idioma vem junto porque o app esconde o header web, onde mora o seletor PT/EN: sem isto o
// leitor não teria como sobrepor a detecção automática — e o público é brasileiro nos EUA, onde
// celular em inglês com leitura em português é comum.
//
// O nativo responde com a URL escolhida; quem navega é a página, para a visita ser um Turbo visit
// normal e entrar na pilha como qualquer link.
export default class extends BridgeComponent {
  static component = "guia-location"

  connect() {
    super.connect()

    const element = this.bridgeElement

    this.send("connect", {
      allLabel: element.bridgeAttribute("all-label"),
      allUrl: element.bridgeAttribute("all-url"),
      currentLabel: element.bridgeAttribute("current-label"),
      currentSlug: element.bridgeAttribute("current-slug"),
      groups: JSON.parse(element.bridgeAttribute("groups")),
      languageLabel: element.bridgeAttribute("language-label"),
      languages: JSON.parse(element.bridgeAttribute("languages"))
    }, (message) => {
      const url = message.data?.url
      if (url) window.Turbo.visit(url)
    })
  }
}
